module.exports = __webpack_public_path__ + "images/site-ad-banner-mobile-fa.webp";